export const RECEIVE_LOGS = "RECEIVE_LOGS";
